/* eslint-disable prettier/prettier */
/* eslint-disable arrow-parens */
import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
const { post, get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "creation";

export const createGroupOwner = async (_payload) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/create-group-owner`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Unauthorized Role!") {
				alert("Unauthorized Role!");
			} else if (message === "An Admin can only create an Employer!") {
				alert("An Admin can only create an Employer!");
			} else if (message === "Invalid Email!") {
				alert("Invalid Email!");
			} else if (message === "Invalid Group!") {
				alert("Invalid Group!");
			} else if (message === "Email is already registered!") {
				alert("Email is already registered!");
			} else if (message === "Invalid SSN!") {
				alert("Invalid SSN!");
			} else if (message === "Cannot enter password during Group Owner creation!") {
				alert("Cannot enter password during Group Owner creation!");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to Create Group Owner!");
			} else alert("Other Errors of Status Code 400");
		} else {
			throw error;
		}
	}
};
